import * as S from "./styles";

export function DefaultFooter() {
  return (
    <S.Container>
      <p>
        Nós da Comparetaxa não cobramos nenhuma taxa de serviço, nem mesmo
        pagamento para simulação ou aprovação de crédito.
      </p>
      <p>
        Atuamos como correspondente bancário dos principais Bancos e quem nos
        remunera é o próprio banco.
      </p>
    </S.Container>
  );
}
